import React from 'react';
import { cn } from '../../lib/utils';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export default function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('d-empty', className)}>
      {Icon && (
        <div className="d-empty-icon">
          <Icon className="w-7 h-7 text-slate-500" />
        </div>
      )}
      <p className="d-empty-title">{title}</p>
      {description && <p className="d-empty-desc">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
